// extracted by mini-css-extract-plugin
module.exports = {"component":"_2xsKqtk3hoXBhgvQAfxFCJ","componentLoading":"_3aeiC6s4Bb865eEpZWIGG_","messageContainer":"_3RrO-8IUkPP-7L673_2U42","fromPatient":"_2g5mgsC73TZl-1OoNcGcNY"};